'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var screenSizes = {
  base: 320,
  tablet: 768,
  desktop: 1024
};

var media = Object.keys(screenSizes).reduce(function (accum, size) {
  accum[size] = size === 'base' ? function (style) {
    return style + ';';
  } : function (style) {
    return '\n      @media (min-width: ' + screenSizes[size] + 'px) {\n        ' + style + ';\n      }\n    ';
  };
  return accum;
}, {});

exports.default = media;


//////////////////
// WEBPACK FOOTER
// ./~/flexomatic/lib/utils/media.js
// module id = 802
// module chunks = 4